import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockCustomerList from './fakes/customer-listing';

const getCustomerFile = (params) => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockCustomerList), 3000);
    });
  }

  const { migrationId } = params;
  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: `/migrations/${migrationId}/customers/download`,
    responseType: 'blob',
  });
}

export default getCustomerFile;

